<template>
  <div class="add-wrapper">
    <div class="add-btn" @click="jumpHandle">
      <i class="iconfont icon-icon_shequzhongxin_xinzeng"></i>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { ref } from 'vue'
const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.33)
const router = useRouter()

const props = defineProps({
  publishType: String,
  boardId: String,
  isAPublishPost: Number,
  isEnablePShare: Number
})

const type = ref<string>(props.publishType as string | 'community')

const jumpHandle = () => {
  if (type.value === 'shortVideo') {
    router.push({ path: '/publishVideo', query: { boardId: props.boardId } })
  } else {
    router.push({
      path: '/communityPublish',
      query: { boardId: props.boardId, isAPublishPost: props.isAPublishPost, isEnablePShare: props.isEnablePShare }
    })
  }
}
</script>

<style lang="less" scoped>
.add-wrapper {
  width: 42px;
  height: 42px;
  background: #fff;
  border-radius: 50%;
  position: fixed;
  right: 16px;
  bottom: 150px;
  z-index: 10;
  .add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, v-bind(themeColor), v-bind(themeColorWithAlpha));
    // background: linear-gradient(180deg,#ffac19, #f37900);
    border-radius: 50%;
    .iconfont {
      color: #ffffff;
      font-size: 20px;
    }
  }
}
</style>
